import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExternalUserService } from '@externaluserservice/external-user.service';
import { ChaseUIDRequest } from '@externalusermodel/AdvancePayment';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';
import { Location } from '@angular/common';


@Component({
  selector: 'app-chase-gateway',
  templateUrl: './chase-gateway.component.html',
  styleUrls: ['./chase-gateway.component.css'],
  providers: [ExternalUserService]
})
export class ChaseGatewayComponent implements OnInit {

  url: string;
  urlSafe: SafeResourceUrl;
  uID: string;
  private sub: any;
  showIframe: boolean;

  chaseOrderId: string;
  paymentType: string;
  profileDetail: any = [];
  UserID: string;
  selectedProfile: any;
  amount: string;

  isCreateNewProfileDisabled: boolean;
  isCreateNewProfileCheckboxDisabled: boolean;
  isProfileSubmitDisabled: boolean;

  createNewProfile: boolean;
  transactionType: string;


  previousRoute: string;

  isPayExistingProfileInProgress: boolean;

// Arvind for message Display
Transactionmessage: boolean;

  constructor(public sanitizer: DomSanitizer, private route: ActivatedRoute, private externalUserService: ExternalUserService, private router: Router, private _location: Location) {
    this.createNewProfile = false;
  }

  ngOnInit() {
    //debugger;
    this.chaseOrderId = this.route.snapshot.params.chaseOrderId;
    this.paymentType = this.route.snapshot.params.paymentType;
    this.transactionType = this.route.snapshot.params.transactionType;
    this.UserID = sessionStorage.getItem('userid');

    switch(this.transactionType)
    {
      case "Invoice":
      this.previousRoute = "InvoiceDetail";
      break;

      case "Advance":
      this.previousRoute = "AdvanceDetail";
      break;

      case "Order":
      this.previousRoute = "OrderDetail";
      break;

      case "OrderInvoice":
      this.previousRoute = "OrderInvoiceDetail";
      break;

      default:
      break;
    }

    this.externalUserService.getTransactionAmountFromChaseOrderId(this.chaseOrderId).subscribe(

      response => {
        // debugger;
        this.amount = response;
      }

    );

    this.externalUserService.getProfileList(this.UserID, this.paymentType).subscribe(

      response => {
        // debugger;
        this.profileDetail = response;
      }

    );

  }


  SelectedState(value) {
    // debugger;
    if (value) {
      this.isCreateNewProfileDisabled = true;
      this.isProfileSubmitDisabled = false;
    }

  }

  goback() {
    sessionStorage.removeItem('selectedAccExe');
    this.router.navigate([this.previousRoute, this.chaseOrderId]);
    //this._location.back();
  }

  PayUsingNewProfile() {
    //debugger;
    
    this.isCreateNewProfileCheckboxDisabled = true;

    let uIDRequestData = new ChaseUIDRequest();
    uIDRequestData.amount = this.amount;
    uIDRequestData.paymentType = this.paymentType;
    uIDRequestData.transactionType = this.transactionType;
    uIDRequestData.chaseOrderId = this.chaseOrderId;
    uIDRequestData.isCreateNewProfile = this.createNewProfile;

    this.externalUserService.GetOrderUId(uIDRequestData)
      .subscribe((result) => {
        //debugger;
        this.uID = result;
        this.url = 'https://www.chasepaymentechhostedpay-var.com/securepayments/a1/cc_collection.php?uID=' + this.uID;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        this.showIframe = true;
        // Arvind for message display.
        this.Transactionmessage = true;
      });
  }

  PayUsingExistingProfile() {
    // debugger;
    let transData = new ChaseProfileTransactionData();

    transData.ChaseOrderId = this.chaseOrderId;
    transData.ProfileReference = this.selectedProfile.chaseProfileID;
    //transData.TransactionAmount = this.amount;
    transData.PaymentType = this.transactionType === 'OrderInvoice' ? 'Invoice' : this.transactionType;

    //console.log(transData);
    
    this.isPayExistingProfileInProgress = true;

    this.externalUserService.ChaseProfileTransaction(transData)
      .subscribe((result) => {
        this.isPayExistingProfileInProgress = false;
        // debugger;

        switch (this.transactionType) {
          case 'Order': {
            this.router.navigate(['OrderStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
          case 'Invoice': {
            this.router.navigate(['InvoiceStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
          case 'OrderInvoice': {
            this.router.navigate(['OrderInvoiceStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
          case 'Advance': {
            this.router.navigate(['AdvancePaymentStatusProfile', this.chaseOrderId, result === 'Success' ? 'Success' : 'Failure']);
            break;
          }
        }

      });

  }

}



// WEBPACK FOOTER //
// ./src/app/chase-gateway/chase-gateway.component.ts